<ng-content select="textarea[ui-input]"></ng-content>
